export default "__VITE_ASSET__CHNjHjt3__"